import { payrollServiceApi } from "../../app/payrollServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { GetQueryArgsType } from "../../types";
import {
  GetDownloadSalaryCertificateType,
  GetEmployeeBreakdownSalaryDetailsResponseType,
} from "../../types/payroll";

export const employeeSalarySettingApi = payrollServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmployeeBreakdownSalaryDetails: builder.query<
      GetEmployeeBreakdownSalaryDetailsResponseType,
      string
    >({
      query: (id) => ({
        url: `${API_URL.getEmployeeBreakdownSalaryDetails}/${id}`,
      }),
      providesTags: ["GetEmployeeBreakdownSalaryDetails"],
    }),
    updateSalaryDetails: builder.mutation({
      query: (data) => ({
        url: API_URL.updateSalaryDetails,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetEmployeeBreakdownSalaryDetails"];
        return [];
      },
    }),
    downloadSalaryCertificate: builder.query<
      void,
      GetQueryArgsType<GetDownloadSalaryCertificateType>
    >({
      query: (queryArgs) => ({
        url: `${API_URL.downloadSalaryCertificate}`,
        responseHandler: async (response: any) => {
          const blob = await response.blob(); // Convert response to blob
          return window.URL.createObjectURL(blob); // Create object URL
        },
        cache: "no-cache",
        ...queryArgs,
      }),
    }),
  }),
});

export const {
  useGetEmployeeBreakdownSalaryDetailsQuery,
  useUpdateSalaryDetailsMutation,
  useLazyDownloadSalaryCertificateQuery,
} = employeeSalarySettingApi;
